import { Button } from "../button";
import { Icon } from "../icons";
import { useTranslation } from "../localization";
import { useRecordingElapsed } from "./use-recording-elapsed";
import { useVideoRecorder } from "./use-video-recorder";

export function VideoRecorderMenu() {
	/** Context */
	const { t } = useTranslation();

	/** Store */
	const controller = useVideoRecorder();

	/** Hooks */
	const elapsed = useRecordingElapsed();

	/** Guard */
	// Before anything is recorded the player's blank slate is the call to action; a second,
	// unlabelled button beside it would only compete with it.
	if (!controller.isRecording && !controller.hasVideo) return null;

	/** Render */
	if (controller.isRecording) {
		return (
			<div className="h-stack w-full **:tabular-nums">
				<Button
					onClick={controller.onStopRecording}
					icon={
						<Icon
							name="Circle"
							className={
								controller.isPaused
									? "fill-primaryGray-400/60 stroke-primaryGray-400"
									: "fill-red-500/80 stroke-red-500"
							}
						/>
					}
				>
					{`${t("video_recorder.stop_recording")} · ${elapsed}`}
				</Button>
				<Button
					variant="ghost"
					onClick={controller.isPaused ? controller.onResumeRecording : controller.onPauseRecording}
					icon={<Icon name={controller.isPaused ? "Play" : "Pause"} />}
				>
					{t(
						controller.isPaused
							? "video_recorder.resume_recording"
							: "video_recorder.pause_recording",
					)}
				</Button>
			</div>
		);
	}

	// Reopens the source picker; the recording in hand is only discarded once a new one
	// actually starts, so dismissing the picker loses nothing.
	return (
		<div className="h-stack w-full justify-end">
			<Button
				variant="ghost"
				onClick={controller.disclosure.onOpen}
				icon={<Icon name="RotateCcw" />}
			>
				{t("videos.re_record")}
			</Button>
		</div>
	);
}
